import React from "react";
import { FormControl } from "react-bootstrap"
import styled from "styled-components"
import { useHistory } from "react-router-dom"
import menu from "../../Sidebar/menu";

const Input = styled(FormControl)`
    font-size: 1em !important;
    border-radius: 5px !important;
    border-bottom: 2px solid red !important;
`

export default props => {
    const [search, setSearch] = React.useState("")

    return <form role="search" className="navbar-form-custom"
        action="#minimeze2">
        <div className="form-group">
            <Input
                placeholder="Pesquisa rápida"
            />
        </div>
    </form>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/FormSearch/index.jsx